import { Link } from 'react-router-dom';
import { Mail, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Logo et Description */}
        <div className="footer-section">
          <div className="footer-logo">
            <div className="footer-logo-icon"></div>
            <span className="footer-logo-text">Le Savoir des Cristaux</span>
          </div>
          <p className="footer-description">
            Encyclopédie de référence en lithothérapie. Découvrez les propriétés,
            l'histoire et les usages des pierres naturelles.
          </p>
        </div>

        {/* Navigation */}
        <div className="footer-section">
          <h3 className="footer-title">Navigation</h3>
          <ul className="footer-links">
            <li><Link to="/encyclopedie">Encyclopédie des Pierres</Link></li>
            <li><Link to="/guides">Guides & Articles</Link></li>
            <li><Link to="/glossaire">Glossaire</Link></li>
            <li><Link to="/a-propos">À Propos</Link></li>
          </ul>
        </div>

        {/* Articles Populaires */}
        <div className="footer-section">
          <h3 className="footer-title">Articles Populaires</h3>
          <ul className="footer-links">
            <li><Link to="/article/pierres-naturelles-regles">Pierres pour les règles</Link></li>
            <li><Link to="/article/pierres-anti-stress">Pierres anti-stress</Link></li>
            <li><Link to="/article/guide-7-chakras">Guide des 7 chakras</Link></li>
            <li><Link to="/article/methodes-purification-pierres">Méthodes de purification</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3 className="footer-title">Contact</h3>
          <div className="footer-contact">
            <Mail size={18} />
            <a href="mailto:contact@pierres.fr">contact@savoirdespierres.fr</a>
          </div>
          <p className="footer-note">
            Site éducatif uniquement. Les informations ne remplacent pas un avis médical professionnel.
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p className="footer-copyright">
          © {currentYear} Savoir des Pierres. Tous droits réservés.
        </p>
        <p className="footer-made-with">
          Créé avec <Heart size={16} className="heart-icon" /> pour les passionnés de lithothérapie
        </p>
      </div>

      <style jsx>{`
        .footer-container {
          background: linear-gradient(135deg, #1a365d 0%, #2d5a8c 100%);
          color: #e8eef5;
          margin-top: auto;
          padding: 3rem 2rem 1.5rem;
        }

        .footer-content {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 3rem;
          margin-bottom: 2.5rem;
        }

        .footer-section {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 0.5rem;
        }

        .footer-logo-icon {
          width: 32px;
          height: 32px;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 6px;
          position: relative;
        }

        .footer-logo-icon::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 16px;
          height: 16px;
          background: #e8eef5;
          clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        }

        .footer-logo-text {
          font-family: 'Playfair Display', serif;
          font-size: 1.15rem;
          font-weight: 600;
          color: #ffffff;
        }

        .footer-description {
          color: rgba(232, 238, 245, 0.8);
          line-height: 1.6;
          font-size: 0.9rem;
        }

        .footer-title {
          font-size: 1.1rem;
          font-weight: 600;
          color: #ffffff;
          margin-bottom: 0.5rem;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 0.6rem;
        }

        .footer-links a {
          color: rgba(232, 238, 245, 0.8);
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.2s ease, padding-left 0.2s ease;
          display: inline-block;
        }

        .footer-links a:hover {
          color: #ffffff;
          padding-left: 0.5rem;
          transform: none;
        }

        .footer-contact {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .footer-contact a {
          color: rgba(232, 238, 245, 0.9);
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.2s ease;
        }

        .footer-contact a:hover {
          color: #ffffff;
          transform: none;
        }

        .footer-note {
          color: rgba(232, 238, 245, 0.7);
          font-size: 0.85rem;
          line-height: 1.5;
          font-style: italic;
        }

        .footer-bottom {
          max-width: 1400px;
          margin: 0 auto;
          padding-top: 2rem;
          border-top: 1px solid rgba(232, 238, 245, 0.2);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .footer-copyright,
        .footer-made-with {
          color: rgba(232, 238, 245, 0.7);
          font-size: 0.85rem;
        }

        .footer-made-with {
          display: flex;
          align-items: center;
          gap: 0.35rem;
        }

        .heart-icon {
          color: #ff6b9d;
          animation: heartbeat 1.5s ease-in-out infinite;
        }

        @keyframes heartbeat {
          0%, 100% { transform: scale(1); }
          25% { transform: scale(1.1); }
          50% { transform: scale(1); }
        }

        @media (max-width: 768px) {
          .footer-container {
            padding: 2rem 1.5rem 1rem;
          }

          .footer-content {
            grid-template-columns: 1fr;
            gap: 2rem;
            margin-bottom: 1.5rem;
          }

          .footer-bottom {
            flex-direction: column;
            text-align: center;
            gap: 0.5rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;